module.exports = __webpack_public_path__ + "img/hr-pipe-straight-horizontal-window.4970d58f.png";